import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/settings")({
  component: () => (
    <div className="flex justify-center h-full p-4 overflow-auto">
      <div className="w-full max-w-3xl">
        <Outlet />
      </div>
    </div>
  ),
});
